<template>
  <div class="sales-shadow mb-2">
    <div class="sales-box p-2" @click.stop.prevent="$emit('openSidebar')">
      <div class="row w-100 mx-1">
        <div class="sales-info-wrapper col-3 p-0">
          <a href="#">
            <div @click.stop.prevent="goToUser" class="sale-ref-id pointer">{{ sale.ref_id }}</div>
          </a>
          <div class="sale-info">
            {{ sale.date }}
          </div>
        </div>
        <div class="sales-info-wrapper col-3 p-0">
          <div class="sale-info-numbers">
            {{ sale.carrier_sale }}
          </div>
        </div>
        <div class="sales-info-wrapper col-3 p-0">
          <div class="sale-info-numbers pl-2">
            {{ sale.cluster_sale }}
          </div>
        </div>
        <div class="sales-info-wrapper col-3 p-0">
          <div class="sale-info-numbers justify-content-end pr-2">
            {{ sale.balance }}
          </div>
          <span v-if="sale.payment_status_id === 3" class="ml-2 sale-status-paid text-center">
            paid
          </span>
        </div>
      </div>
    </div>
    <div v-if="expanded" class="sales-box p-2" @click.stop.prevent="$emit('openSidebar')">
      <div class="border-top-expanded row mx-1 w-100">
        <div class="col-12 row mt-2 pr-0">
          <div class="col-3">
            <label class="expanded-label">Time</label>
            <div class="expanded-col-data">
              {{ sale.time }}
            </div>
          </div>
          <div class="col-3">
            <label class="expanded-label">Tips</label>
            <div class="expanded-col-data">
              {{ sale.card_tips }}
            </div>
          </div>
          <div class="col-3">
            <label class="expanded-label">Fee</label>
            <div class="expanded-col-data">
              {{ sale.mod_tier_id ? `${sale.mod_tier_percentage}%` : `${sale.percent}% (${sale.fee })` }}
            </div>
          </div>
        </div>
        <div class="col-12 row mt-2 pr-0">
          <div class="col-3">
            <label class="expanded-label">Deposit</label>
            <div class="expanded-col-data">
              {{ sale.deposit }}
            </div>
          </div>
          <div class="col-3">
            <label class="expanded-label">Cash</label>
            <div class="expanded-col-data">
              {{ sale.cash_payment }}
            </div>
          </div>
          <div class="col-3">
            <label class="expanded-label">Credit</label>
            <div class="expanded-col-data">
              {{ sale.sale_credit }}
            </div>
          </div>
          <div class="col-3">
            <label class="expanded-label">Grand sale</label>
            <div class="expanded-col-data">
              {{ sale.sale_price }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SalesTotalsBlockMobile',
  props: {
    sale: {
      type: Object,
      default: () => ({}),
    },
    expanded: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    goToUser() {
      window.open(this.$router.resolve(`/users/edit/${this.sale.id}`).href, '_blank');
    },
  },
};
</script>

<style scoped>
.sales-box {
  display: flex;
  justify-content: space-between;
  background: #ffffff;
  border-radius: 2px;
  min-height: 70px;
}

.sales-shadow {
  box-shadow: 0 2px 9px -4px rgba(15, 20, 54, 0.17), 0 7px 25px -3px rgba(50, 50, 93, 0.03);
}

.sales-box > div:first-child > div:first-child {
  padding: 12px 0 0 12px !important;
}
.sales-info-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.sale-ref-id {
  font-weight: bold;
  font-size: 12px;
  color: #4c5669;
}
.sale-ref-id:hover {
  color: #2962ff;
}
.sale-info {
  font-size: 10px;
  color: #4c5669;
}
.sale-info-numbers {
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4c5669;
}
.sales-icon {
  color: #c0c6cc;
}

.expanded-label {
  font-weight: bold;
  font-size: 12px;
  color: #4c5669;
  white-space: nowrap;
}

.expanded-col-data {
  font-size: 12px;
  color: #4c5669;
}

.border-top-expanded {
  border-top: 1px solid #bdbdbd;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/sales/SalesTotalsBlockMobile.vue